<template>
  <div>
    <img :src="captImg" height="100%" v-show="false"/>
    <canvas ref="canvas" id="canvas" width="1000" height="1350" v-show="false"/>

    <div class="ocrSpinner" v-if="captImg!=null">
      <q-spinner size="25px" color="primary"/>
      <div style="margin-top:10px">OCR läuft...</div>
    </div>

    <div class="row justify-center">
      <video ref="video" width="500" id="video" autoplay playsinline="playsinline" :style="captImg!=null?'visibility:hidden;':''"/>
    </div>
    <!--
        <div class="row justify-end">
                  <video ref="video" width="400" height="400" id="video" autoplay playsinline="true" style="border: 2px solid red;"/>
          <q-btn color="secondary" label="Start OCR" @click="doOCR" class="q-ma-sm"/>
        </div>
    -->
  </div>
</template>

<script>
  import { createWorker } from 'tesseract.js'

  export default {
    name: 'ocr-comp',
    data() {
      return {
        video: {},
        canvas: {},
        captImg: null,
        stream: null
      }
    },

    methods: {
      capture() {
        this.canvas = this.$refs.canvas
        var context = this.canvas.getContext("2d").drawImage(this.video, 0, 0, 1000, 1350);
        this.captImg = this.canvas.toDataURL("image/png")
      },

      start() {
        this.video = this.$refs.video;
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          navigator.mediaDevices.getUserMedia({video: {facingMode: {exact: "environment"}}})
            .then(stream => {
              this.stream = stream
              this.video.src = window.URL.createObjectURL(stream)
              this.video.play()
            })
            .catch(error => {
              navigator.mediaDevices.getUserMedia({video: true})
                .then(stream => {
                  this.stream = stream
                  this.video.srcObject = stream
                  this.video.play()
                })
                .catch(error => {
                  this.$emit('OCRError', error)
                })
            })
            .finally(() => {
            })
        } else {
          console.error("Could not load user media (camera, microphone).")
        }
      },

      stop() {
        this.video.pause();
        this.video.src = ''
        for (let i = 0; i < this.stream.getTracks().length; i++) {
          this.stream.getTracks()[i].stop()
        }
      },

      // -----------------------------------------------------------
      // ------------------------- OCR Scan ------------------------
      // -----------------------------------------------------------
      async doOCR() {
        this.capture()
        var hostname = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');
        const worker = createWorker({
          workerPath: hostname + '/statics/ocr/worker.js',
          corePath: hostname + '/statics/ocr/tesseract-core.js',
          langPath: hostname + '/statics/ocr/'
        })

        try {
          await worker.load()
          await worker.loadLanguage('deu');
          await worker.initialize('deu');
          let result = await worker.recognize(this.captImg) //{ lang: 'deu'}  "http://localhost:8090/statics/ocr.png"
          console.log("OCR result", result)
          this.captImg = null
          this.$emit('OCRDone', result.data.text)
        } catch (e) {
          console.log("OCR error", e)
        }
      }
    },

    beforeUnmount: function () {
      this.stop()
      this.eventBus.off('onOCR', this.doOCR)
    },

    destroyed: function () {
      console.log('Destroyed');
    },

    mounted() {
      this.start()
      this.eventBus.on('onOCR', this.doOCR)
    }
  }
</script>

<style lang="sass">
  .ocrSpinner
    position: absolute
    top:50%
    left: 0
    width: 100%
    text-align: center
    font-size:13px
</style>
